/*
 *   File : dropdown.js
 *   Author URI : www.evoqins.com
 *   Description : Selectbox
 *   Integrations : null
 *   Version : v1.0
 *   Created : 
 */

/* import package */
import React, { Fragment, useEffect, useState, useContext } from "react";
import Select, { components } from "react-select";

/* import components */
import Icon from "../Icon/icon";

import Colors from '../../Styles/color.module.scss';

import { DarkModeContext } from "../../Context/dark-mode-context";

const SelectDropDown = (props) => {
    const { darkMode } = useContext(DarkModeContext);

    const [value, setValue] = useState("");
    const [check, setCheck] = useState(false);
    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <Icon icon="right-arrow"
                    width="20px"
                    height="20px"
                    color={darkMode === true ? Colors.white : Colors.space_cadet} />
            </components.DropdownIndicator>
        );
    };

    const customStyles = {
        container: (defaultStyles, state) => ({
            ...defaultStyles,
            zIndex: "2"
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            margin: "0"
        }),
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderRadius: props.radius ? props.radius : "6px",
            border:  darkMode === true ? `1px solid ${Colors.gunmetal_gray}` : `1px solid ${Colors.bright_gray}`,
            background: darkMode === true ? Colors.eerie_black : props.background ? props.background : Colors.white,
            padding: props.padding ? props.padding : "8px",
            boxShadow: "none",
            "&:hover": {
                border: darkMode === true ? `1px solid ${Colors.dusty_gray}` : `1px solid ${Colors.bright_gray}`,
                cursor: 'pointer',
            },
        }),
        valueContainer: (defaultStyles) => ({
            ...defaultStyles,
            padding: "0px",
        }),
        menu: (defaultStyles) => ({
            ...defaultStyles,
            width: "247px",
            right: "0",
            border: darkMode === true ? `2px solid ${Colors.gunmetal_gray}` : `2px solid ${Colors.gainsboro}`,
            background: darkMode === true  ? Colors.eerie_black : Colors.white,
            boxShadow: "0px 4px 20px -10px rgba(0, 0, 0, 0.25)",
            borderRadius: "12px",
        }),

        menuList: (defaultStyles, state) => ({
            ...defaultStyles,
            padding: '8px 10px',
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            maxHeight: "max-content"
        }),

        dropdownIndicator: (defaultStyles, state) => ({
            ...defaultStyles,
            padding: "0",
            marginLeft: "4px",
            transition: "transform 0.2s",
            transform: state.selectProps.menuIsOpen === true ? "rotate(-90deg)" : "rotate(90deg)"
        }),
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            padding: "0",
            color: Colors.black,
            fontFamily: "Poppins-regular",
            fontSize: "14px",
            fontStyle: " normal",
            fontWeight: " 400",
            backgroundColor: darkMode === true ? Colors.eerie_black : Colors.white,
            borderRadius: "12px",
            cursor: "pointer",
            "&:active": {
                backgroundColor: darkMode === true ? Colors.eerie_black : Colors.white,
            },

        }),

        singleValue: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: "14px",
            lineHeight: "24px"
        }),
    };

    const _onSelectChange = (value) => {
        props.onSelectChange(value)
    }


    const _handleMenuToggle = () => {
        // console.log('jfkd,', isOpen)
        if (props.onMenuToggle) {
            setCheck(!check);
            props.onMenuToggle(!check);
        }
    };

    const CustomSingleValue = ({ children, ...props }) => (
        <components.SingleValue {...props}>
            <div className="d-flex gap-8px" onClick={_handleMenuToggle}>
                <span className={`${darkMode === true ? 'color-white' : 'color-outer-space'} e-poppins-regular e-font-14 line-height-24px`}>
                    {props.selectProps.placeholder}
                </span>
                <span className={`e-poppins-medium ${darkMode === true ? 'color-white' : 'color-charleston-green'}`}>{children}</span>
            </div>
        </components.SingleValue>
    );

    // Custom Option component with the icon
    const CustomOption = ({ children, isSelected, ...props }) => (
        <components.Option {...props}>
            <div className="d-flex align-items-center gap-10px" >
                {
                    isSelected ?
                        <Icon icon="radio-selected"
                            size={24} />
                        :
                        <Icon icon="radio-unselected"
                            size={24} />
                }
                <span className={isSelected ? "e-poppins-medium" : "e-poppins-regular"}>{children}</span>
            </div>
        </components.Option>
    );

    return (
        <Fragment>
            <div className={`${props.className} position-relative`}>
                <Select value={value}
                    styles={customStyles}
                    isSearchable={false}
                    options={props.options}
                    placeholder={props.placeholder}
                    // menuIsOpen={true}
                    components={{
                        DropdownIndicator,
                        IndicatorSeparator: null,
                        Option: CustomOption,
                        SingleValue: CustomSingleValue,
                    }}
                    // onMenuOpen={() => _handleMenuToggle(true)} // Call the function when the menu opens
                    // onMenuClose={() => _handleMenuToggle(false)}
                    onChange={(value) => {
                        _onSelectChange(value)
                    }}
                />
            </div>

        </Fragment>
    );
}

export default SelectDropDown;